module.exports = __webpack_public_path__ + "static/media/M.21048662.svg";